import * as React from "react";
import * as ReactDom from "react-dom";
import KruskalComponent from "./kruskal/KruskalComponent";
import PrimComponent from "./prim/PrimComponent";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
ReactDom.render(React.createElement(App, null), document.getElementById("app"));
function App() {
    return (React.createElement(Router, null,
        React.createElement("div", { className: "w-full p-12 flex flex-row justify-center h-auto" },
            React.createElement(Switch, null,
                React.createElement(Route, { path: "/prims" },
                    React.createElement("div", { className: "w-8/12 bg-white rounded-md shadow-md" },
                        React.createElement(PrimComponent, null))),
                React.createElement(Route, { path: "/kruskal" },
                    React.createElement("div", { className: "w-8/12 bg-white rounded-md shadow-md" },
                        React.createElement(KruskalComponent, null))),
                React.createElement(Route, { path: "" },
                    React.createElement("div", { className: "w-8/12 bg-white rounded-md shadow-md p-16" },
                        React.createElement(Link, { to: "/prims", className: "text-blue-600 underline" }, "Goto Prims Algorithm"),
                        React.createElement("br", null),
                        React.createElement(Link, { to: "/kruskal", className: "text-blue-600 underline" }, "Goto Kruskal Algorithm")))))));
}
